/** Returns an updater removing a key from an object. */
export const withoutKey = (key) => (prev) => {
  if (!prev || !(key in prev)) return prev;
  const next = { ...prev };
  delete next[key];
  return next;
};

/** Returns an updater adding a value to a set. */
export const addToSet = (value) => (prev) => new Set([...(prev || []), value]);

/** Returns an updater removing a value from a set. */
export const removeFromSet = (value) => (prev) => {
  const next = new Set(prev || []);
  next.delete(value);
  return next;
};

/** Returns an updater removing a value from an array. */
export const removeFromArray = (value) => (prev) =>
  (prev || []).filter((item) => item !== value);

/** Returns an updater inserting a value before another in an array, or appending it. */
export const insertBefore = (value, before) => (prev) => {
  const order = prev || [];
  if (order.includes(value)) return order;
  const index = order.indexOf(before);
  const next = [...order];
  next.splice(index >= 0 ? index : next.length, 0, value);
  return next;
};
